import React from 'react'

// components
import { useValidateUserRelation } from '@/shared/hooks/profilePage'

import { Text } from '@/components/commons/typography/Text'
import { RequestConnectionButton } from '@/components/requestConnectionButton/RequestConnectionButton'
import { ChatSendMessageToastContext } from '@/components/chat/ChatSendMessageToast/ChatSendMessageToastProvider'
import { ButtonComponent } from '@/components/commons'
import { EmptyConnectionCard } from './EmptyConnectaionCard'
import { useProfile } from 'containers/profile/hooks/useProfile'
import { RecommendationsList } from '@/components/pages/profile_v2'
import { IUser } from '@/interfaces/user'

export const NoSocialConnectedOtherProfile = () => {
  const { profile } = useProfile()
  const { isConnection, isInvited, isInvitedBy, isOwnProfile } =
    useValidateUserRelation(profile?.id)
  const { showToast } = React.useContext(ChatSendMessageToastContext)
  const showConnectButton =
    !isConnection && !isInvited && !isInvitedBy && !isOwnProfile

  if (!profile) {
    return null
  }

  return (
    <div className="flex flex-column gap-30 full-w">
      <div className="flex flex-column items-center justigy-center full-w gap-16">
        <EmptyConnectionCard>
          <div className="flex items-center--desktop flex-column flex-row--desktop justify-space-between--desktop gap-24">
            <div className="flex items-center gap-12">
              <div>
                <Text sizeClass="text-38">🧐</Text>
              </div>
              <div>
                <Text
                  sizeClass="text-12"
                  weightClass="font-bold"
                  lineHeightClass="leading-16"
                >
                  {profile.username} has yet to connect their social accounts
                </Text>
                {showConnectButton && (
                  <Text sizeClass="text-12">
                    Connect and let them know you’re interested in their work!
                  </Text>
                )}
              </div>
            </div>
            <div>
              <RequestConnectionButton profileFromProps={profile as IUser} />
              {isConnection && (
                <ButtonComponent
                  variation="secondary"
                  size="small"
                  label="Message"
                  onClick={() => showToast([profile as IUser])}
                />
              )}
            </div>
          </div>
        </EmptyConnectionCard>
      </div>
      <div className="flex flex-column gap-30">
        <RecommendationsList />
      </div>
    </div>
  )
}
